import ErrorContainer from '@/components/error/error-404'
import BatchExec from '@/pages/batch/batchExec'
import BatchFailList from '@/pages/batch/batchFailList'
import BizMgmt from '@/pages/bizMgmt/bizMgmt'
import DetailBizMgmt from '@/pages/bizMgmt/detail/detailBizMgmt'
import ComCode from '@/pages/code/comCode'
import DetailComCode from '@/pages/code/detailComCode'
import DetailInqrMgmt from '@/pages/inqr/detailInqrMgmt'
import InqrMgmt from '@/pages/inqr/inqrMgmt'
import Login from '@/pages/login/login'
import LoginHistMgmt from '@/pages/loginHist/loginHistMgmt'
import Main from '@/pages/main/main'
import DetailMemberMgmt from '@/pages/member/detail/detailMemberMgmt'
import MemberMgmt from '@/pages/member/memberMgmt'
import DetailNoticeMgmt from '@/pages/notice/detailNoticeMgmt'
import NoticeMgmt from '@/pages/notice/noticeMgmt'
import PriceBulkMgmt from '@/pages/price/priceBulkMgmt'
import PriceMgmt from '@/pages/price/priceMgmt'
import ScrpMgmt from '@/pages/scrp/scrpMgmt'
import TermsAgreeMgmt from '@/pages/terms/agree/termsAgreeMgmt'
import DetailTermsMgmt from '@/pages/terms/detailTermsMgmt'
import TermsMgmt from '@/pages/terms/termsMgmt'
import MessageMgmt from '@/pages/message/messageMgmt'
import DetailMessageMgmt from '@/pages/message/detailMessageMgmt'
import DetailLoginHistMgmt from '@/pages/loginHist/detail/detailLoginHistMgmt'
import DetailBizHistMgmt from '@/pages/bizMgmt/hist/detailBizHistMgmt'
import ComLog from '@/pages/comLog/comLog'
import DetailComLog from '@/pages/comLog/detailComLog'
import PriceHistMgmt from '@/pages/price/priceHistMgmt'
import ScrpInfoMgmt from '@/pages/scrp/scrpInfoMgmt'
import Youtube from '@/pages/youtube/youtube'
import DetailYoutube from '@/pages/youtube/detailYoutube'
import InsertYoutube from '@/pages/youtube/insertYoutube'
import DetailYoutubeHist from '@/pages/youtube/detailYoutubeHist'
import HolidayMgmt from '@/pages/holiday/holidayMgmt'
import DetailHolidayMgmt from '@/pages/holiday/detailHolidayMgmt'
import ComSurvey from '@/pages/survey/comSurvey'
import DetailComSurvey from '@/pages/survey/detailComSurvey'
import InsertSurvey from '@/pages/survey/insertSurvey'
import ComPrmt from '@/pages/prmt/comPrmt'
import DetailComPrmt from '@/pages/prmt/detailComPrmt'
import PriceIntgMgmt from '@/pages/priceIntg/priceIntgMgmt'
import MenuInfoMgmt from '@/pages/menu/info/menuInfoMgmt'
import DetailMenuInfoMgmt from '@/pages/menu/info/_component/detailMenuInfoMgmt'
import FeedbackMgmt from '@/pages/feedback/feedbackMgmt'
import DetailFeedbackMgmt from '@/pages/feedback/detailFeedbackMgmt'
import BlogMgmt from '@/pages/blog/blogMgmt'
import DetailBlogMgmt from '@/pages/blog/detailBlogMgmt'
import AnswerMgmt from '@/pages/answer/answerMgmt'

export const routes = [
  {
    path: '/',
    element: <Login />,
    hideHeader: true,
    hideFooter: true,
    fullWidth: true,
  },
  {
    path: '/main',
    element: <Main />,
    requireAuth: true,
  },
  {
    path: '/bizMgmt',
    element: <BizMgmt />,
    label: '업체관리',
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/bizMgmt/priceMgmt',
    element: <PriceMgmt />,
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/bizMgmt/priceHistMgmt',
    element: <PriceHistMgmt />,
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/bizMgmt/detail',
    element: <DetailBizMgmt />,
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/bizMgmt/detailHist',
    element: <DetailBizHistMgmt />,
    requireAuth: true,
  },
  {
    path: '/memberMgmt',
    element: <MemberMgmt />,
    label: '회원관리',
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/bizMgmt/scrpMgmt',
    element: <ScrpMgmt />,
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/batchExec',
    element: <BatchExec />,
    label: '배치관리',
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/batchExec/batchFailList',
    element: <BatchFailList />,
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/termsMgmt',
    element: <TermsMgmt />,
    label: '약관관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/termsMgmt/detail',
    element: <DetailTermsMgmt />,
    requireAuth: true,
  },
  {
    path: '/inqrMgmt',
    element: <InqrMgmt />,
    label: '문의관리',
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/inqrMgmt/detail',
    element: <DetailInqrMgmt />,
    requireAuth: true,
  },
  {
    path: '/noticeMgmt',
    element: <NoticeMgmt />,
    label: '공지관리',
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/noticeMgmt/detail',
    element: <DetailNoticeMgmt />,
    requireAuth: true,
  },
  // {
  //   path: '/priceBulkMgmt',
  //   element: <PriceBulkMgmt />,
  //   label: '수기관리',
  //   requireAuth: true,
  //   isFullWidth: true,
  // },
  {
    path: '/memberMgmt/detail',
    element: <DetailMemberMgmt />,
    requireAuth: true,
  },
  {
    path: '/messageMgmt',
    element: <MessageMgmt />,
    label: '메시지관리',
    requireAuth: true,
    parent: '기타관리',
  },
  {
    path: '/messageMgmt/detail',
    element: <DetailMessageMgmt />,
    requireAuth: true,
  },
  {
    path: '/memberMgmt/termsAgree',
    element: <TermsAgreeMgmt />,
    requireAuth: true,
    isFullWidth: true,
  },
  {
    path: '/loginHistMgmt',
    element: <LoginHistMgmt />,
    label: '로그인이력관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/loginHistMgmt/detail',
    element: <DetailLoginHistMgmt />,
    requireAuth: true,
  },
  {
    path: '/code',
    element: <ComCode />,
    label: '공통코드관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/code/detail',
    element: <DetailComCode />,
    requireAuth: true,
  },
  {
    path: '/comLog',
    element: <ComLog />,
    label: '로그관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/comLog/detail',
    element: <DetailComLog />,
    requireAuth: true,
  },
  {
    path: '/scrpInfoMgmt',
    element: <ScrpInfoMgmt />,
    requireAuth: true,
  },
  {
    path: '/youtube',
    element: <Youtube />,
    label: '유튜브관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/youtube/detail',
    element: <DetailYoutube />,
    requireAuth: true,
  },
  {
    path: '/youtube/insert',
    element: <InsertYoutube />,
    requireAuth: true,
  },
  {
    path: '/youtube/detailHist',
    element: <DetailYoutubeHist />,
    requireAuth: true,
  },
  {
    path: '/holiday',
    element: <HolidayMgmt />,
    label: '휴일관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/holiday/detail',
    element: <DetailHolidayMgmt />,
    requireAuth: true,
  },
  {
    path: '/survey',
    element: <ComSurvey />,
    label: '투표관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/survey/insert',
    element: <InsertSurvey />,
    requireAuth: true,
  },
  {
    path: '/survey/detail',
    element: <DetailComSurvey />,
    requireAuth: true,
  },
  {
    path: '#',
    element: <></>,
    isDropdown: true,
    label: '기타관리',
  },
  {
    path: '/prmt',
    element: <ComPrmt />,
    label: '이벤트관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/prmt/detail',
    element: <DetailComPrmt />,
    requireAuth: true,
  },
  {
    path: '/priceIntgMgmt',
    element: <PriceIntgMgmt />,
    label: '통합가격이력관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/menu/info',
    element: <MenuInfoMgmt />,
    label: '메뉴알림관리',
    requireAuth: true,
    parent: '기타관리',
  },
  {
    path: '/menu/info/detail',
    element: <DetailMenuInfoMgmt />,
    requireAuth: true,
  },
  {
    path: '/feedbackMgmt',
    element: <FeedbackMgmt />,
    label: '목소리관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/blogMgmt',
    element: <BlogMgmt />,
    label: '소통관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/answerMgmt',
    element: <AnswerMgmt />,
    label: '템플릿관리',
    requireAuth: true,
    isFullWidth: true,
    parent: '기타관리',
  },
  {
    path: '/feedbackMgmt/detail',
    element: <DetailFeedbackMgmt />,
    requireAuth: true,
  },
  {
    path: '/blogMgmt/detail',
    element: <DetailBlogMgmt />,
    requireAuth: true,
  },
  {
    path: '*',
    element: <ErrorContainer />,
  },
]
